import React from "react";
import SubscriptionForm from "./ManageSubscriptionForm";
import { LeftPanel, MainContainer, RightPanel } from "../login/LoginLayout";
import { StackPanelLogo } from "../login/StackCarePanelLogo";
import AccountManagementHeader from "../login/AccountManagementHeader";
import LeftPanelFooter from "../login/LeftPanelFooter";
import SubscriptionManagementOptions from "./SubscriptionManagementOptions";
import SignOut from "./SignOut";

export default function UpdateSubscriptions() {
  /* ---- Hooks ---- */
  return (
    <MainContainer>
      <LeftPanel>
        <StackPanelLogo />
        <AccountManagementHeader />
        <SubscriptionManagementOptions />
        <SignOut />
        <LeftPanelFooter />
      </LeftPanel>
      <RightPanel>
        <SubscriptionForm />
      </RightPanel>
    </MainContainer>
  );
}
